<div class="main-content">
  <div
    class="header-wrapper"
    [ngClass]="selected ? 'selected' : ''"
    [tabindex]="tabIndex"
    (click)="onClick()"
    (keydown)="onKeydown($event)"
  >
    <div class="ice-select-header">
      <div class="label-container">
        <label class="label" [for]="value" (click)="$event.preventDefault()">{{ label }}</label>
        @if (helpLabel) {
          <span>
            {{ helpLabel }}
          </span>
        }
      </div>
      <div class="right-content">
        <ng-content select="[inlineHeaderContent]" />
        @if (!readonly) {
          @if (isRadio) {
            <input
              tabindex="-1"
              type="radio"
              [attr.data-testid]="radioTestId()"
              [id]="value"
              [ngClass]="{ selected: control?.value === value || selected }"
              [value]="value"
            />
          } @else if (isCheckbox) {
            <input
              #checkboxInput
              class="checkbox"
              tabindex="-1"
              type="checkbox"
              [attr.data-testid]="checkboxTestId()"
              [checked]="selected"
              [disabled]="disabled"
              [id]="value"
              [ngClass]="{ selected: selected }"
              [value]="value"
            />
          }
        }
      </div>
    </div>
    <div #headerContent class="ice-select-custom-header" [ngClass]="{ 'has-header': hasCustomHeader }">
      <ng-content select="[header]" />
    </div>
  </div>
  <div
    class="content-container"
    [attr.inert]="!selected ? '' : null"
    [ngClass]="{ 'has-body': hasBodyContent && selected }"
    [ngStyle]="{ overflow: hideOverflow ? 'hidden' : 'unset' }"
  >
    <div #bodyContent class="content-section">
      <ng-content />
    </div>
  </div>
</div>
@if (reserveSpaceForInfoText() || !!infoText) {
  <span
    class="icon-container"
    matTooltipPosition="below"
    [class.icon-container--hidden]="!infoText"
    [matTooltip]="infoText || ''"
    [matTooltipDisabled]="!infoText"
  >
    @if (!!infoText) {
      <mat-icon [svgIcon]="IconNames.ice_info_filled" />
    }
  </span>
}
